import { motion } from 'motion/react';

const ShakeMotion = ({
  children,
  className = '',
  disabled = false,
  type = 'tween',
  duration = 0.4,
  delay = 0.1,
  xAxis = 20,
  style = {},
  shake = false,
}) => {
  const getAnimation = () => {
    if (shake) {
      return [0, -xAxis, xAxis, -xAxis, xAxis, 0];
    }
    return [0];
  };
  return (
    <motion.div
      key={shake}
      className={className}
      initial={{ x: 0 }}
      animate={
        disabled
          ? false
          : {
              x: getAnimation(),
            }
      }
      transition={{
        x: {
          duration,
          type,
          delay,
          repeatType: 'reverse',
        },
      }}
      style={style}>
      {children}
    </motion.div>
  );
};

export default ShakeMotion;
